module.exports = __webpack_public_path__ + "static/img/blurred-background-full.f91a225.jpg";